import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';


/***** 兼容处理 *****/
import 'babel-polyfill';
import promise from 'es6-promise';
promise.polyfill();
import 'core-js/stable';
import 'regenerator-runtime/runtime';

/***** 依赖 *****/
// swiper
import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.min.css';
// element-ui
import { Pagination, Backtop, Icon } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// video-player
import VideoPlayer from 'vue-video-player';
import 'vue-video-player/src/custom-theme.css';
import 'video.js/dist/video-js.css';

import './style/base.less';

Vue.use(VueAwesomeSwiper).use(Pagination).use(Backtop).use(Icon)
  .use(VideoPlayer);


Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
